import { render, staticRenderFns } from "./passModal.vue?vue&type=template&id=68f8ec0f&"
import script from "./passModal.vue?vue&type=script&lang=js&"
export * from "./passModal.vue?vue&type=script&lang=js&"
import style0 from "./passModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports